/* eslint-disable */

/*
 * NOTICE: this file is a hacked version of the code found here:
 * https://www.npmjs.com/package/react-ssr-error-boundary
 *
 * ... and it's basically one giant train wreck. Do not read too much
 * into the quality of the code you find here, because you will not
 * like it.
 *
 * ... but it works.
 *
 */

import React, { Component } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';

// Array to store React contexts
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const contexts: any[] = [];

// Use specific context
// @ts-ignore
export function loadContext(Context) {
    contexts.push(Context);
}

// Clear contexts in use
export function clearContexts() {
    contexts.length = 0;
}

// Shim `React.createContext()` to capture contexts
let shimmed = false;

export function shim() {
    if (shimmed) return;
    shimmed = true;

    const { createContext } = React;
    // @ts-ignore
    React.createContext = function () {
        // @ts-ignore
        const Context = createContext.apply(this, arguments);
        contexts.push(Context);
        return Context;
    };
}

// Create Provider component for specific context types
export function makeProvider(contextTypes: any) {
    return class ProvideContext extends Component {
        static childContextTypes = contextTypes;

        getChildContext() {
            // @ts-ignore
            return this.props.context;
        }

        render() {
            return this.props.children;
        }
    };
}

// Server-side render, propagating contexts to children
// @ts-ignore
export function doRender(self, ProvideContext) {
    // Wrap element in provider for legacy context
    const element = (
        <ProvideContext context={self.context}>
            {self.props.children}
        </ProvideContext>
    );

    // Wrap element in consumers and providers for new context.
    // Consumers are added outside HTML render, to capture value of all contexts.
    // Providers are added inside HTML render, to reinject context values back
    // into the rendered element.
    return stackConsumers((values: any) => {
        const elementWithProviders = stackProviders(element, values);

        try {
            void renderToStaticMarkup(elementWithProviders);

            return elementWithProviders;
        } catch (e) {
            return <div>{self.props.fallBack(e)}</div>;
        }
    });
}

// Create stack of consumer components
function stackConsumers(retFn: { (values: any): JSX.Element; (arg0: any[]): void; }) {
    const values: any[] | never[] = [];
    let fn = () => retFn(values);

    for (let i = 0; i < contexts.length; i++) {
        const Context = contexts[i];
        const childFn = fn;

        fn = () => (
            <Context.Consumer>
                {(value: any) => {
                    values[i] = value;
                    return childFn();
                }}
            </Context.Consumer>
        );
    }

    return fn();
}

// Create stack of provider components
function stackProviders(element: JSX.Element, values: any[]) {
    for (let i = 0; i < values.length; i++) {
        const Context = contexts[i];
        const childElement = element;

        element = (
            <Context.Provider value={values[i]}>
                {childElement}
            </Context.Provider>
        );
    }

    return element;
}
